import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, MessageSquare, Check } from "lucide-react";
import api from "../lib/api";

// Council → Beacons: creators who just hit a member milestone, so the Council can congratulate them.
export const BeaconMilestonesPanel = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  const load = () => api.get("/admin/beacon-milestones").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  const done = async (id) => { setItems((x) => x.map((m) => (m.id === id ? { ...m, done: true } : m))); await api.post(`/admin/beacon-milestones/${id}/done`).catch(() => {}); };
  if (!items) return null;
  const open = items.filter((m) => !m.done);
  return (
    <div className="border border-[#D4AF37]/30 bg-[#121212] p-4 mb-6" data-testid="beacon-milestones-panel">
      <div className="flex items-center gap-2 mb-1">
        <Sparkles size={16} className="text-[#D4AF37]" />
        <h3 className="font-body text-sm text-white">Milestones</h3>
        {open.length > 0 && <span className="bg-[#A855F7] text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full" data-testid="beacon-milestones-count">{open.length}</span>}
      </div>
      <p className="font-body text-xs text-zinc-500 mb-3">Creators who just reached a member milestone. A quick congratulations goes a long way.</p>
      {items.length === 0 ? <p className="font-body text-xs text-zinc-600" data-testid="beacon-milestones-empty">No milestones yet.</p> : (
        <div className="divide-y divide-white/5">
          {items.slice(0, 20).map((m) => (
            <div key={m.id} className={`flex items-center gap-3 py-2.5 flex-wrap ${m.done ? "opacity-50" : ""}`} data-testid={`beacon-milestone-row-${m.id}`}>
              <span className="font-display text-xl text-[#D4AF37] w-12 shrink-0">{m.milestone}</span>
              <span className="flex-1 min-w-0">
                <span className="block font-body text-sm text-white truncate">{m.beacon_title || "A Beacon"}</span>
                <span className="block font-body text-[11px] text-zinc-500">{new Date(m.created_at).toLocaleDateString()} · {m.milestone === 1 ? "first member" : `${m.milestone} members`}</span>
              </span>
              <button type="button" onClick={() => { done(m.id); navigate(`/messages/${m.owner_id}`); }} data-testid={`beacon-milestone-congrats-${m.id}`}
                className="flex items-center gap-1.5 border border-[#14A89A]/60 text-[#14A89A] hover:bg-[#14A89A] hover:text-[#0A0A0A] px-3 py-1.5 font-body text-xs transition-colors">
                <MessageSquare size={13} /> Send congratulations
              </button>
              {!m.done && <button type="button" onClick={() => done(m.id)} data-testid={`beacon-milestone-done-${m.id}`} className="flex items-center gap-1 text-zinc-500 hover:text-white font-body text-xs"><Check size={13} /> Mark done</button>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
